import { reportLogQueueForPageHide } from '../report/reportLogQueueForPageHide';

let pageHideAttempts = 0;
let reportLogQueueForCurrentPageHide: ((event: PageTransitionEvent) => void) | undefined;

type AddPageHideQueueObservationEventListener = (shouldDeliverQueuedLogEvents?: boolean) => void;
export const addPageHideQueueObservationEventListener: AddPageHideQueueObservationEventListener = (
  shouldDeliverQueuedLogEvents = false
) => {
  if (reportLogQueueForCurrentPageHide) {
    window.removeEventListener('pagehide', reportLogQueueForCurrentPageHide);
  }

  reportLogQueueForCurrentPageHide = (event) => {
    pageHideAttempts += 1;
    reportLogQueueForPageHide(
      {
        attempts: pageHideAttempts,
        persisted: event.persisted,
      },
      shouldDeliverQueuedLogEvents
    );
  };
  window.addEventListener('pagehide', reportLogQueueForCurrentPageHide);
};
